import { render, staticRenderFns } from "./allnote2.vue?vue&type=template&id=5b76d866&scoped=true&"
import script from "./allnote2.vue?vue&type=script&lang=js&"
export * from "./allnote2.vue?vue&type=script&lang=js&"
import style0 from "./allnote2.vue?vue&type=style&index=0&id=5b76d866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b76d866",
  null
  
)

export default component.exports